import { render } from "./Date.vue?vue&type=template&id=34b840a2&lang=html"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/fieldTypes/Date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34b840a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34b840a2', __exports__)) {
    api.reload('34b840a2', __exports__)
  }
  
  module.hot.accept("./Date.vue?vue&type=template&id=34b840a2&lang=html", () => {
    api.rerender('34b840a2', render)
  })

}


export default __exports__